export default class MongoNotificationProjectFunded {
  projectId = "";
  projectTitle = "";
  projectLogoUrl = "";
}
